<template>
  <transition name="slide-x">
    <div class="me-toast" v-if="active">
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  name: 'meToast',
  props: {
    message: {
      type: String,
      default: '',
      required: true
    },
    time: {
      type: Number,
      default: 5000,
    }
  },
  data() {
    return {
      active: false,
      handle: null
    }
  },
  methods: {
    show() {
      this.active = true;
      if(this.handle) {
        window.clearTimeout(this.handle);
      }
      this.handle = window.setTimeout(() => this.hide(), this.time);
    },
    hide() {
      this.active = false
      this.handle = null
    }
  }
}
</script>

<style lang="stylus" scoped>

  // vue transition
  .slide-x
    
    &-enter-active
    &-leave-active
      transition all 1.2s

    &-enter
    &-leave-to
      opacity 0
      transform: translateX(50%)
    
  .me-toast
    min-width 200px
    max-width 320px
    padding 1rem
    background white
    border-radius 4px
    box-shadow 2px 3px 5px -1px rgba(0,0,0,.2),
                3px 6px 10px 0 rgba(0,0,0,.14), 
                4px 1px 18px 0 rgba(0,0,0,.12)
    position fixed
    bottom 2%
    right 1%
    z-index 999
    font-size 14px
    color #054FA0

</style>
